<template>
  <khrc-navbar/>
  <research-fellows-component />
</template>

<script>
import KhrcNavbar from "@/components/KhrcNavbar.vue";
import ResearchFellowsComponent from "@/components/ResearchFellowsComponent";
export default {
  components: {
    KhrcNavbar,
    ResearchFellowsComponent,
  },
};
</script>

<style></style>
